<template>
    <div
        :class="`text-capitalize ${cursor}`"
        @click="showFullDate = !showFullDate"
    >
        {{ activityTimeDate }}
    </div>
</template>

<script>
export default {
    props: {
        activityTime: {
            type: String,
            required: true,
        },
        maxLen: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            showFullDate: false,
            cursor: "",
            formatStr: this.$options.filters.formatString,
        };
    },
    computed: {
        activityTimeDate() {
            if (this.activityTime.length > this.maxLen) this.cursor = "pointer";
            return this.showFullDate
                ? this.activityTime
                : this.formatStr(this.activityTime, this.maxLen);
        },
    },
};
</script>

<style lang="css" scoped>
.pointer {
    cursor: auto;
}
</style>>
